import * as Effect from 'effect/Effect';
import { pipe } from 'effect/Function';
import { AppLayer } from '@/api/client';
import { logger } from '@/lib/logger';

// Utility function to run effects
export const runEffect = <A>(effect: Effect.Effect<A, unknown, unknown>): Promise<A> =>
  Effect.runPromise(
    pipe(
      Effect.provide(effect, AppLayer) as Effect.Effect<A, unknown, never>,
      Effect.tapError((error) =>
        Effect.sync(() => {
          logger.error('Effect runtime error', error);
        })
      )
    )
  );

// Utility function to run effects with error handling
export const runEffectSafe = <A>(
  effect: Effect.Effect<A, unknown, unknown>
): Promise<A | null> =>
  Effect.runPromise(
    Effect.provide(
      Effect.catchAll(effect, () => Effect.succeed(null)),
      AppLayer
    ) as unknown as Effect.Effect<A | null, unknown, never>
  );

// Utility function for sync effects
export const runEffectSync = <A>(effect: Effect.Effect<A, never, unknown>): A =>
  Effect.runSync(Effect.provide(effect, AppLayer) as Effect.Effect<A, never, never>);